import { object, string } from "yup";

const today = new Date();
const currentMonth = today.getMonth() + 1;
const currentYear = today.getFullYear() % 100;

const isValidDate = (value) => {
    if (!value) return false;
    const [enteredMonth, enteredYear] = value.split("/");
    const month = parseInt(enteredMonth, 10);
    const year = parseInt(enteredYear, 10);
    return month >= 1 && month <= 12 && year >= currentYear;
};

const isNotExpired = (value) => {
    if (!value) return true;
    const [enteredMonth, enteredYear] = value.split("/");
    return (
        parseInt(enteredYear, 10) > currentYear ||
        (parseInt(enteredYear, 10) === currentYear && parseInt(enteredMonth, 10) >= currentMonth)
    );
};

export default object({
  full_name: string()
    .required("Name is required")
    .matches(/^[A-Za-z\s]+$/, "Name must contain only letters and spaces"),
    date: string()
    .required("Date is required")
    .matches(/^\d{2}\/\d{2}$/, "Date must be in the format DD/YY")
    .test("valid-date", "Invalid date", isValidDate)
    .test("not-expired", "Date expired", isNotExpired),
  zip: string()
    .required("Billing zip is required")
    .matches(/^\d{5}(-\d{4})?$/, "Invalid zip code format"),
});
